import { useAuth } from '../../../__legacy__/hooks/useAuth'
import axios from 'axios'

export const useMintingAPI = () => {
  const { authenticatedGet } = useAuth()

  const getMerkleProof = async (editionId: number, walletAddress: string) => {
    const { data } = await axios.get<{ proof: string[] }>('/api/v2/merkle-proof', {
      params: {
        editionId,
        walletAddress
      }
    })
    return data.proof
  }

  return { getMerkleProof }
}
